/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Port } from './Port';
import {
    PortFromJSON,
    PortFromJSONTyped,
    PortToJSON,
} from './Port';

/**
 * 
 * @export
 * @interface CRSFSecReviewHoneypot
 */
export interface CRSFSecReviewHoneypot {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewHoneypot
     */
    asset: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewHoneypot
     */
    created: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewHoneypot
     */
    found: number;
    /**
     * 
     * @type {Port}
     * @memberof CRSFSecReviewHoneypot
     */
    port: Port;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewHoneypot
     */
    shared?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewHoneypot
     */
    source_asset?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewHoneypot
     */
    tags: Array<string>;
}

/**
 * Check if a given object implements the CRSFSecReviewHoneypot interface.
 */
export function instanceOfCRSFSecReviewHoneypot(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asset" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "found" in value;
    isInstance = isInstance && "port" in value;
    isInstance = isInstance && "tags" in value;

    return isInstance;
}

export function CRSFSecReviewHoneypotFromJSON(json: any): CRSFSecReviewHoneypot {
    return CRSFSecReviewHoneypotFromJSONTyped(json, false);
}

export function CRSFSecReviewHoneypotFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewHoneypot {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': json['asset'],
        'created': json['created'],
        'found': json['found'],
        'port': PortFromJSON(json['port']),
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'source_asset': !exists(json, 'source_asset') ? undefined : json['source_asset'],
        'tags': json['tags'],
    };
}

export function CRSFSecReviewHoneypotToJSON(value?: CRSFSecReviewHoneypot | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'created': value.created,
        'found': value.found,
        'port': PortToJSON(value.port),
        'shared': value.shared,
        'source_asset': value.source_asset,
        'tags': value.tags,
    };
}

